import { adminApi, ipRegistry, ipStackClient, adminabpApi, cardsActivityadminApi, developConfigApi, cardsServiceApi } from ".";
import { ApiControllers } from "./config";
import CryptoJS from "crypto-js";
const convertUTCToLocalTime = (dateString) => {
  let date = new Date(dateString);
  const milliseconds = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  );
  const localTime = new Date(milliseconds);
  return localTime.toISOString();
};
const getErrorMessage = (objValue) => {
  if (typeof objValue?.data?.error === "object" && objValue?.data?.error?.message) {
    return objValue?.data?.error?.message;
  }
  return "Something went wrong please try again!";
};

const getDataMessage = (objValue) => {
  if (objValue?.data && typeof objValue?.data === "string") {
    return objValue?.data;
  }
  if (objValue?.data?.title && typeof objValue?.data?.title === "string") {
    return objValue?.data?.title;
  }
  return null;
};

const getOriginalErrorMessage = (objValue) => {
  if (typeof objValue?.originalError?.message === "string") {
    return objValue?.originalError?.message;
  }
  return null;
};

const getFallbackMessage = (objValue) => {
  if (typeof objValue === "object" && objValue?.reason) {
    return objValue?.reason;
  }
  return "Something went wrong please try again!";
};

const isErrorDispaly = (objValue) => {
  if (objValue?.status >= 400 && objValue?.status <= 500 && objValue?.status !== 401) {
    return getErrorMessage(objValue);
  }

  const dataMessage = getDataMessage(objValue);
  if (dataMessage) {
    return dataMessage;
  }

  const originalErrorMessage = getOriginalErrorMessage(objValue);
  if (originalErrorMessage) {
    return originalErrorMessage;
  }

  return getFallbackMessage(objValue);
};
const uploadErrorDisplay = (objValue) => {
  if ((objValue?.status >= 400 && objValue?.status < 500) && objValue?.status != 401) {
    return "Something went wrong please try again!";
  } else if (objValue?.title && typeof objValue?.title) {
    return objValue?.title;
  } else {
    return "Something went wrong please try again!";
  }
}
const fetchAdminDetails = () => {
  return adminabpApi.get(`application-configuration?includeLocalizationResources=false`)
}
const encryptValue = (msg, key) => {
  msg = typeof msg == "object" ? JSON.stringify(msg) : msg;
  let salt = CryptoJS.lib.WordArray.random(128 / 8);
  let key1 = CryptoJS.PBKDF2(key, salt, {
    keySize: 256 / 32,
    iterations: 10,
  });
  let iv = CryptoJS.lib.WordArray.random(128 / 8);
  let encrypted = CryptoJS.AES.encrypt(msg, key1, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  return salt.toString() + iv.toString() + encrypted.toString();
};
const getIpRegistery = () => {
  return ipRegistry.get("/?key=" + process.env.REACT_APP_IPREGISTERY_KEY);
};
const getIpStack = () => {
  return ipStackClient.get('check?access_key=' + process.env.REACT_APP_IPSTACK_KEY)
}

const getLookups = (url => {
  return adminApi.get(url);
})
const getCategoryLookups = (url => {
  return adminApi.get(url);
})
const saveCategory = (tenantId, obj) => {
  return developConfigApi.put(ApiControllers.cardsManageservice + `Cards/Category/${tenantId}`, obj)
}
const getCardsLookups = (url => {
  return cardsActivityadminApi.get(ApiControllers.CardsActivityService + url);
})
const cardDetails = (url, id, tenantId) => {
  return adminApi.get(ApiControllers.cardsManageservice + `${url}/${id}/${tenantId}`)
}
const getTenantCards = (id) => {
  return adminApi.get(`/CardsManageService/TenantCards/${id}`)
}
const getLookupsForCardForm = () => {
  return adminApi.get(ApiControllers.CardsActivityService + `CardCreation`);
}
const getCountries = () => {
  return adminApi.get(ApiControllers.CardsActivityService + `CountryLu`)
}
const getpaidCurrencyluData = () => {
  return adminApi.get(ApiControllers.CardsActivityService + "Cards/PaidCurrencyLu")
}
const getCardDetails = (url) => {
  return adminApi.get(ApiControllers.cardsManageservice + `Cards/${url}`)
}
const postNewCard = (obj) => {
  return developConfigApi.post(ApiControllers.cardsManageservice + `cardSave`, obj);
}
const updateExistingCard = (obj) => {
  return developConfigApi.put(ApiControllers.cardsManageservice + `UpdateCard`, obj);
}
const updateCardStatus = (obj) => {
  return developConfigApi.put(ApiControllers.cardsManageservice + `cardStatusUpdate`, obj)
}
const getProviderLu = () => {
  return adminApi.get(ApiControllers.CardsActivityService + "ProviderLu")
}
const tenentCardsSave = (obj) => {
  return developConfigApi.post(`/CardsManageService/adminCardsSave`, obj)
}
const cardsActiveInActive = (id, obj) => {
  return developConfigApi.put(`/CardsManageService/CardsActiveInActive/${id}`, obj)
}
const getwebHookUrl = (tenantId) => {
  return adminApi.get(ApiControllers.cardsManageservice + `WebHookUrl/${tenantId}`)
}
const getDevKey = (tenantId) => {
  return adminApi.get(ApiControllers.cardsManageservice + `GetKeys/${tenantId}`)
}
const savedevConfig = (obj, tenantId) => {
  return developConfigApi.put(ApiControllers.cardsManageservice + `WebHookSave/${tenantId}`, obj)
}
const savedevKey = (obj, tenantId) => {
  return developConfigApi.post(ApiControllers.cardsManageservice + `Keys/${tenantId}`, obj)
}
const getToken = (tenantId) => {
  return adminApi.get(ApiControllers.cardsManageservice + `Tokens/${tenantId}`)
}
const assaignedcardsUpdate = (obj) => {
  return developConfigApi.put(`/CardsManageService/assaignedcards`, obj)
}
const getMaintenanceUnit = () => {
  return adminApi.get(ApiControllers.CardsActivityService + `MaintenanceUnitLu`)
}
const gettotalAssets = (tenantId) => {
  return adminApi.get(ApiControllers.CardsActivityService + `PortfolioBalances/${tenantId}`)
}
const get = (url) => {
  return adminApi.get(ApiControllers.cardsManageservice + `${url}`)
}
const getKycRequirement = () => {
  return adminApi.get(ApiControllers.CardsActivityService + `KYCRequirementLu`)
}
const getSupportedPlatForms = () => {
  return adminApi.get(ApiControllers.CardsActivityService + `SupportedPlatForms`)
}
const topUpCards = (obj) => {
  return developConfigApi.put(`/CardsManageService/UpdateTopUpStateChange`, obj)
}
const getCreateVault = (tenantid,programId) => {
  return adminApi.get(ApiControllers.cardsManageservice + `Create/VaultAccountId/${tenantid}/${programId}`)
}
const walletAddress = (walletId, tenantId) => {
  return adminApi.get(ApiControllers.CardsActivityService + `Wallet/${walletId}/${tenantId}`)
}
const getTransferLookups = (url) => {
  return cardsActivityadminApi.get(url);
}
const getTransferSave = (obj) => {
  return developConfigApi.post(`Transfer/SaveTransfer`, obj);
}
const kycDetails = (id, tenantId) => {
  return adminApi.get(ApiControllers.cardsManageservice + `KycDetails/${id}/${tenantId}`);
}
const getkycStatusLu = () => {
  return adminApi.get(ApiControllers.cardsManageservice + `KycStateChangeLu/KycStatuslu`);
}
const saveKYCState = (obj) => {
  return developConfigApi.put(ApiControllers.cardsManageservice + `CardApproval`, obj);
}
const getTopupCoinLu = (url) => {
  return cardsActivityadminApi.get(url);
}
const topUpsave = (obj) => {
  return developConfigApi.post(`Transfer/MerchantTransfer`, obj);
}
const saveCancelCard = (obj) => {
  return developConfigApi.put(`CardsManageService/CancelCard`, obj);
}
const kybDetails = (tenantId) => {
  return adminApi.get(`KycService/GetKybDetails/${tenantId}`)
}
const saveTemplate = (obj, tenantId) => {
  return developConfigApi.post(ApiControllers.caseManagement + `SaveCaseTemplate/${tenantId}`, obj);
}
const deleteCaseTemplate = (templateId, tenantId) => {
  return developConfigApi.delete(ApiControllers.caseManagement + `DeleteTemplate/${templateId}/${tenantId}`)
}
const casesTemplate = (tenantId) => {
  return developConfigApi.get(ApiControllers.caseManagement + `TemplateLu/${tenantId}`);
}
const casesModules = () => {
  return developConfigApi.get(ApiControllers.caseManagement + `CaseModulesLookUp`);
}
const transactionData = () => {
  return developConfigApi.get(ApiControllers.caseManagement + `CaseModulesLookUp`);
}
const assignAdmins = (name, tenantId) => {
  return developConfigApi.get(ApiControllers.caseManagement + `AdminUsers/${name}`);
}
const adminData = (screenId, screenName, tenantId, isAdmin) => {
  return developConfigApi.get(ApiControllers.caseManagement + `Cases/${screenId}/${screenName}/${tenantId}/${isAdmin}`);
}
const featchCaseDetails = (id, tenantId) => {
  return developConfigApi.get(ApiControllers.caseManagement + `Admin/Case/${id}/${tenantId}`)
}
const createCase = (tenantId, obj) => {
  return developConfigApi.post(ApiControllers.caseManagement + `Cases/Case/${tenantId}`, obj);
}
const getDocumentReplies = (caseId, tenantId) => {
  return developConfigApi.get(ApiControllers.caseManagement + `Accounts/${caseId}/Messages/${tenantId}`);
}
const getStateChangeLu = (fromStatus, tenantId) => {
  return developConfigApi.get(ApiControllers.caseManagement + `StateChange/Cases/${fromStatus}/${tenantId}`)

}
const getCurrenciesLu = () => {
  return adminApi.get(`/CardsActivityService/CurrencyLu`)
}
const getStatusLu = () => {
  return adminApi.get(ApiControllers.cardsManageservice + `StatusLu`)
}
const updateStateChange = (tenantId, obj) => {
  return developConfigApi.put(ApiControllers.caseManagement + `Cases/Status/${tenantId}`, obj)
}
//-------------------------Energy-------------------------
const getAvailableCredits = (tenantId) => {
  return cardsServiceApi.get(ApiControllers.energy + `availablecredits/${tenantId}`)
}
const getCreditsAmount = (value) => {
  return cardsServiceApi.get(ApiControllers.energy + `amount/${value}`)
}
const getAddress = (tenantId) => {
  return cardsServiceApi.get(ApiControllers.energy + `address/${tenantId}`)
}
const depositSave = (obj, tenantId) => {
  return cardsServiceApi.post(ApiControllers.energy + `credits/${tenantId}`, obj)
}
const getUsedCredits = (days, tenantId) => {
  return cardsServiceApi.get(ApiControllers.energy + `usedCredits/${days}/${tenantId}`);
}
const getAddressTypes = (tenantId) => {
  return cardsServiceApi.get(`energy/addressLu/${tenantId}`);
}
const saveRechargeEnergy = (tenantId, obj) => {
  return cardsServiceApi.post(`Recharge/${tenantId}`, obj)
}
const getTopupAddressLu = (tenantId) => {
  return cardsServiceApi.get(`energy/topupAddress/${tenantId}`);
}
const getTransactionsAddressLu = (tenantId) => {
  return cardsServiceApi.get(`energy/transactionsAddress/${tenantId}`);
}
//-------------------------Energy-------------------------
const paginatedApiUrl = (apiUrl,pageSize,pageNumber) => {
  return cardsServiceApi.get(`${apiUrl}?skipCount=${pageNumber}&maxResultCount=${pageSize}`);
}

const getSupportTokenCoinLu = () => {
  return developConfigApi.get(ApiControllers.cardsManageservice + `GetSupportedCoins`);
}
const updateSupportToken = (obj) => {
  return developConfigApi.post(ApiControllers.cardsManageservice + `SaveProgramSupportedToken`, obj);
}
const getChangeTokenData = (id) => {
  return developConfigApi.get(ApiControllers.cardsManageservice + `ProgramSupportedTokenLu/${id}`);
}
const saveKycStatus = (iskyckyb,tenantId) => {
  return developConfigApi.get(ApiControllers.cardsManageservice + `Update/KYCKYB/${iskyckyb}/${tenantId} `);
}
const apiCalls = {
  isErrorDispaly, fetchAdminDetails, encryptValue, getIpRegistery, uploadErrorDisplay,
  convertUTCToLocalTime, getIpStack,
  cardDetails, getLookups, getCardsLookups, getTenantCards,
  getLookupsForCardForm, getCountries, getpaidCurrencyluData, getCardDetails, getProviderLu, postNewCard, updateExistingCard, updateCardStatus, getMaintenanceUnit,
  tenentCardsSave, cardsActiveInActive, getKycRequirement, getSupportedPlatForms,
  getwebHookUrl, getDevKey, savedevConfig, savedevKey, getToken, assaignedcardsUpdate, gettotalAssets, get, topUpCards, getCreateVault, walletAddress, getTransferLookups, getTransferSave, kycDetails,
  getkycStatusLu, saveKYCState, getTopupCoinLu, topUpsave, saveCancelCard, kybDetails,
  saveTemplate, deleteCaseTemplate, casesTemplate, casesModules, transactionData, assignAdmins, adminData,
  featchCaseDetails, createCase, getDocumentReplies, getStateChangeLu, updateStateChange, getCategoryLookups, saveCategory, getCurrenciesLu, getStatusLu,
  getAvailableCredits, getCreditsAmount, getAddress, depositSave, getUsedCredits, getAddressTypes, saveRechargeEnergy, getTopupAddressLu, getTransactionsAddressLu,paginatedApiUrl,
  getSupportTokenCoinLu,getChangeTokenData,updateSupportToken,saveKycStatus
}
export default apiCalls